const FromArrEditor = [{
		key: 'InvClass',
		modelvalue: undefined,
		title: "产 品 线 ：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 135,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
	}, {
		key: 'BusinessProvinceID',
		modelvalue: undefined,
		title: "经营省份：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 135,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 400,
		options: [],
	}, {
		key: 'Name',
		title: "名   称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 125,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 0,
		displayVal: "inline-block",
		fontWeightVal: 400
	},
	{
		key: 'StartDate',
		title: "启效日期：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 135,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 400
	},
	{
		key: 'EndDate',
		title: "有效期至：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 135,
		height: 32,
		disabled: false,
		marginLeft: 21,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 400
	}
];
export default FromArrEditor;